import { PAYMENT_LOGS, PAYMENT_LOGS_SUCCESS, PAYMENT_LOGS_ERROR, PAYMENT_LOGS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PaymentLogs = (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_LOGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PAYMENT_LOGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PAYMENT_LOGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PAYMENT_LOGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PaymentLogs;
